import { render, staticRenderFns } from "./TaskModelForm.vue?vue&type=template&id=2c1f4c42&"
import script from "./TaskModelForm.vue?vue&type=script&lang=js&"
export * from "./TaskModelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports